import type Product from '@src/quince-site-common/src/domains/Product'
import type { ISubscriptionPlan } from '@src/quince-site-common/src/domains/Subscription'

import type React from 'react'

export const PURCHASE_TYPES = {
  SUBSCRIBE: 'SUBSCRIBE',
  ONE_TIME: 'ONE_TIME',
} as const

export type PurchaseType = (typeof PURCHASE_TYPES)[keyof typeof PURCHASE_TYPES]

export interface FrequencyOption {
  value: string
  label: string
  isRecommended?: boolean
}

export interface PurchaseTypeSelectorProps {
  subscriptionId: string | undefined
  value: PurchaseType
  onChange: (value: PurchaseType) => void
  subscribeLabel?: string
  oneTimeLabel?: string
  name?: string
  variantSubscriptionPlans: ISubscriptionPlan[]
  selectedPlanId: number | undefined
  onPlanIdChange: (planId: number | undefined) => void
  formattedSubscriptionPrice: string
  formattedFestivalOfferPrice?: string
  formattedSalePrice: string
  subscriptionFestivalSavingPercentage?: number
  isFromPdp?: boolean
  showNewPdpDesignV2?: boolean
  product: Product
}

export interface PurchaseTypeSelectorShimmerProps {
  showShimmer: boolean
  isFromPdp: boolean
  showNewPdpDesignV2: boolean
  children: React.ReactNode
}
